import { render, staticRenderFns } from "./ms-write-report.vue?vue&type=template&id=1f2057f7&scoped=true"
import script from "./ms-write-report.vue?vue&type=script&lang=js"
export * from "./ms-write-report.vue?vue&type=script&lang=js"
import style0 from "./ms-write-report.vue?vue&type=style&index=0&id=1f2057f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2057f7",
  null
  
)

export default component.exports